import type { AbsolutePath } from '@hub/router';
import type { ReactNode } from 'react';
import { createContext } from 'react';

/** Severity markers for quick-action rows, keyed by the row's target path. */
export type QuickActionStatus = Readonly<Partial<Record<AbsolutePath, ReactNode>>>;

export interface QuickActionStatusContextValue {
  status: QuickActionStatus;
  publish: (source: string, status: QuickActionStatus) => void;
  clear: (source: string) => void;
}

/** Null where no provider is mounted (public pages, most tests): rows render unadorned and publishing is a no-op. */
export const QuickActionStatusContext = createContext<QuickActionStatusContextValue | null>(null);
